import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ExitTrapComponent,
  OverlayPanelComponent,
  ScrollablePanelComponent,
  StickyPanelComponent,
  GlobalErrorHandlerComponent,
  SuspenseComponent,
} from '../components';
import {
  AutosaveFormDirective,
  ObservableElementDirective,
  CurrencyInputDirective,
  IntegerInputDirective,
} from '../directives';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReloadPopupComponent } from '../components/reload-popup/reload-popup.component';
import { AgGridModule } from 'ag-grid-angular';
import { TestRouteComponent } from '../components';

const ABSTRACT_COMPONENTS = [
  ScrollablePanelComponent,
  StickyPanelComponent,
  OverlayPanelComponent,
  ExitTrapComponent,
  ReloadPopupComponent,
  GlobalErrorHandlerComponent,
  SuspenseComponent,
  TestRouteComponent,
];

const ABSTRACT_DIRECTIVES = [
  ObservableElementDirective,
  AutosaveFormDirective,
  CurrencyInputDirective,
  IntegerInputDirective,
];

const MODULE_EXPORTS = [...ABSTRACT_COMPONENTS, ...ABSTRACT_DIRECTIVES];

@NgModule({
  declarations: MODULE_EXPORTS,
  exports: MODULE_EXPORTS,
  imports: [CommonModule, NgbModule, AgGridModule],
})
export class AbstractComponentsModule {}
